export const AGREE_SCALE = 'AGREE_SCALE';
export const CHECKBOX = 'CHECKBOX';
export const DROPDOWN = 'DROPDOWN';
export const MOST_LEAST = 'MOST_LEAST';
export const SINGLE_RESPONSE = 'SINGLE_RESPONSE';
export const TRUE_FALSE = 'TRUE_FALSE';
export const TABULAR_CHECKBOX = 'TABULAR_AGREE';
export const TABULAR_TRUE_FALSE = 'TABULAR_TRUE_FALSE';
